:root {
  --store-logo-width: 72px;
}

.storeCard {
  width: 100%;
  color: var(--bloom-colors-header-contrast-text-label);
  border-radius: 0px;
  padding: 0px 24px 24px;
  white-space: nowrap;
  margin-bottom: 24px;
  border-bottom: 1px solid var(--bloom-colors-store-card-border);
}

.storeCard:not(.storeCard--selected):last-of-type {
  border: none;
}

.storeCard--selected {
  border-radius: var(--border-radius-lg);
  background-color: var(--bloom-colors-store-button);
  border: 2px solid var(--bloom-colors-header-contrast-text-label);
  color: var(--bloom-colors-header-contrast-text-label);
  padding: 24px;
}

.storeCardInner {
  display: flex;
  gap: 12px;
  min-height: var(--store-logo-width);
}

.image {
  max-height: var(--store-logo-width);
  max-width: var(--store-logo-width);
}

.content {
  text-align: start;
  min-width: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.header {
  display: flex;
  gap: 8px;
}

.distanceTag {
  background-color: var(--colors-transparent-black-ten);
  color: var(--bloom-colors-header-contrast-text-label);
  border-radius: 8px;
  margin-left: auto;
}

.reservationModeTag {
  color: var(--bloom-colors-header-contrast);
  background-color: var(--bloom-colors-header-contrast-text-label);
  border-radius: 8px;
}

.storeType {
  display: flex;
  justify-content: space-between;
}

.label {
  background-color: var(--colors-secondary-main);
  color: var(--bloom-colors-secondary-contrast);
  border-radius: 8px;

  & > p {
    font-size: 13px;
  }
}

.storeComms {
  display: flex;
  justify-content: space-between;
}

.selectStoreButton {
  display: block;
}

.selectStoreButton div {
  transform: none;
  margin: auto;
  position: static;
}
